<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t('carta.Cartas') }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right" >
          <router-link to="new-carte"><vs-button color="primary" type="border">{{ $t('carta.NuevaCarta') }}</vs-button></router-link>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" link="carte">
            <template v-slot:actions="slotProps" >
              <div class="dropdown-button-container">
                <router-link :to="{ name: 'publicCarta', params: { id: slotProps.item.id, slug: slotProps.item.slug_restaurant, lang: language }}" target="_blank" >
                  <vs-button class="btnx" type="filled" color="primary" :disabled="isItemActive(slotProps.item.active)">
                    {{ $t('Ver') }}
                  </vs-button>
                </router-link>
                <vs-dropdown vs-trigger-click>
                  <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
                  <vs-dropdown-menu>
                    <ul style="min-width: 12rem">
                      <li>
                        <generate-qr
                          :id="slotProps.item.id"
                          class="cursor-pointer py-3 px-4 block hover:bg-primary text-primary hover:text-white w-full"
                          type="cartedish"
                        >
                          <template slot="text" >
                              <font-awesome-icon
                                :icon="['fas', 'qrcode']"
                                class="w-4 h-4"
                              />
                            <span class="ml-2 mt-5">
                              {{ $t('GenerarQR') }}
                            </span>
                          </template>
                        </generate-qr>
                      </li>

                      <vs-divider class="m-1" />
                      <li>
                        <router-link :to="slotProps.item.linkEdit" class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full" >
                          <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Editar') }}</span>
                        </router-link>
                      </li>
                      <vs-divider class="m-1" />
                      <li>
                        <span @click="deleteModalCarte(slotProps.item.id, slotProps.item.name)" class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full" >
                          <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Eliminar') }}</span>
                        </span>
                      </li>
                    </ul>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </template>
            <template v-slot:active="slotProps" >
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
                @click="deactiveModalCarte(slotProps.item.id, slotProps.item.name)"
              />
            </template>
            <template v-slot:deactive="slotProps" >
              <feather-icon
                icon="XCircleIcon"
                svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
                @click="activeModalCarte(slotProps.item.id, slotProps.item.name)"
              />
            </template>
            <template v-slot:name="slotProps" >
              <a
                target="_blank"
                :href="$router.resolve({ name: 'publicCarta', params: { id: slotProps.item.id, slug: slotProps.item.slug_restaurant, lang: language}}).href"
                class="text-primary hover:text-black"
              >
                {{slotProps.item.name}}
              </a>
            </template>
          </table-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
    import TableDataGrid from '../components/TableDataGrid';
    import GenerateQr from '../components/GenerateQr';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        components: {
            TableDataGrid,
            GenerateQr
        },
        data () {
            return {
                dialog: false,
                dataColumns: [
                    {dataField: 'id', caption: 'ID', visible: false},
                    {caption: 'linkEdit', visible: false},
                    {caption: this.$t('Imagen'), dataType: 'image', visible: true, width: 175},
                    {dataField: 'active', caption: this.$t('Activo'), dataType: 'slot', visible: true, width: 100},
                    {dataField: 'itemName', caption: this.$t('Nombre'), dataType: 'slot', visible: true, width: 250},
                    {caption: this.$t('Descripcion'), visible: true, width: 600},
                    {caption: this.$t('IdiomasTraducidos'), dataType: 'text', visible: true, width: 150},
                    {caption: 'Slug', dataType: 'text', visible: false},
                    {visible: false}
                ]
            }
        },
        created () {
            this.refreshCartes({language: this.language});
        },
        computed: {
            ...mapGetters({
                languages: 'getLanguages',
                itemsCartes: 'getCartes',
                language: 'getCurrentLanguage'
            }),
            itemsDataGrid () {
                const items = this.itemsCartes;
                const results = [];
                const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
                const aux = this;

                items.forEach(function (item, index) {
                    const langs = new Array();
                    const auxLangs = eval(items[index].available_languages);

                    if (auxLangs) {
                      auxLangs.forEach(function (ln) {
                        langs.push(aux.languages[ln]);
                      });
                    }

                    results[index] = {
                        id: items[index].id,
                        linkEdit: `edit-carte/${  items[index].id}`,
                        image: `<img src="${  placeholder  }" style="width: 175px;" class="product-img" >`,
                        active: 'deactive',
                        itemName: 'name',
                        description: items[index].description,
                        languages: langs.join(', '),
                        slug_restaurant: items[index].slug_restaurant,
                        name: items[index].name
                    };
                    if (items[index].images[0]) {
                        results[index].image = `<img src="${  items[index].images[0].path  }" style="width: 175px;" class="product-img" >`;
                    }
                    if (items[index].active === 1) {
                        results[index].active = 'active';
                    }

                }, items)

                return results
            }
        },
        methods: {
            ...mapActions({
                refreshCartes: 'refreshCartes',
                activeCarte: 'activeCarte',
                deactiveCarte: 'deactiveCarte',
                deleteCarte: 'deleteCarte',
                generateQR: 'generateQR'
            }),
            deleteModalCarte (id, name) {
                const aux = this;
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('carta.EliminarCarta'),
                    text: this.$t('carta.EliminarConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.deleteCarte(id)
                    }
                })
            },
            isItemActive (active) {
              if (active == 'active') {
                return false;
              } else {
                return true;
              }
            },
            activeModalCarte (id, name) {
                const aux = this;
                this.$vs.dialog({
                    type:'confirm',
                    color: 'success',
                    title: this.$t('carta.ActivarCarta'),
                    text: this.$t('carta.ActivarConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.activeCarte(id)
                    }
                })
            },
            deactiveModalCarte (id, name) {
                const aux = this;
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('carta.DesactivarCarta'),
                    text: this.$t('carta.DesactivarConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.deactiveCarte(id)
                    }
                })
            }
        }
    }

</script>

<style>

</style>
